import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { Text } from "appworks/graphics/pixi/text";
import { Services } from "appworks/services/services";
import { deepClone } from "appworks/utils/collection-utils";
import { gameLayers } from "game-layers";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { SymbolComponent } from "slotworks/components/matrix/symbol/symbol-component";

const TierMultiplierMap = new Map([
    ["GRAND", 1000], // GRAND
    ["MAJOR", 200],  // MAJOR
    ["MINOR", 100],  // MINOR
    ["MINI", 50]     // MINI
]);

export class DMFSymbolComponent extends SymbolComponent {

    protected quickhitText: Text;
    protected lastValue: number;

    public tint(color: number) {
        const tintElementMaps = [this.staticSprites];

        if (this.quickhitText) {
            this.quickhitText.tint = color;
        }

        for (const elementMap of tintElementMaps) {
            elementMap.forEach((element) => {
                if (element) {
                    element.tint = color;
                }
            });
        }

        this.tintColor = color;
    }

    protected updateStatic(transform: DualPosition) {
        const symbolId: string = this.symbolId;

        let value: number;
        if (/^QH_.*/.test(this.symbolId)) {
            const mStr: string = this.symbolId.replace(/^QH_/, "");
            const multiplier: number = parseInt(mStr);
            value = multiplier / 100 * Services.bet.getTotalStake();
            this.symbolId = "QH";
        } else if (/^QHj.*/.test(this.symbolId)) {
            const tStr: string = this.symbolId.replace(/^QHj/, "");
            const multiplier: number = TierMultiplierMap.get(tStr);
            value = multiplier / 100 * Services.bet.getTotalStake();
        }

        if (this.quickhitText && this.lastValue !== value) {
            if (this.quickhitText.parent) {
                this.quickhitText.parent.removeChild(this.quickhitText);
            }
            this.lastValue = value;
            this.quickhitText.destroy();
            this.quickhitText = null;
        }

        super.updateStatic(transform);
        this.symbolId = symbolId;

        if (!this.quickhitText && value) {
            const templateText: Text = gameLayers.Templates.elements.default.quickhit_text;

            this.quickhitText = new Text("", deepClone(templateText.style));
            this.staticSprite.addChild(this.quickhitText);

            this.quickhitText.text = PartnerConnectManager.getCurrencyFormatter().format(value).replace(" ", "").replace(/\.00$/, "");

            this.quickhitText.pivot = templateText.pivot.clone();
            this.quickhitText.anchor = templateText.anchor.clone();
            this.quickhitText.landscape = templateText.landscape.clone();

            this.quickhitText.landscape.width = this.staticSprite.landscape.width * 0.3;
            this.quickhitText.landscape.height = this.staticSprite.landscape.height * 0.5;

            this.quickhitText.landscape.x = this.quickhitText.landscape.width * -0.45;
            this.quickhitText.landscape.y = this.quickhitText.landscape.height * -0.66;

            this.quickhitText.style.wordWrap = false;

            this.quickhitText.updateTransform();
        }
    }
}
